Prefix = require("lib/prefix")

# Because the ClientRect is immutable, provide an interface to return a
# mutable copy with an optional { x, y } offset.
getBounds = (el, offset = { x: 0, y: 0 }) ->
  {top, left, right, bottom, width, height} = el.getBoundingClientRect()

  top: top + offset.y
  left: left + offset.x
  right: right + offset.x
  bottom: bottom + offset.y
  width: width
  height: height

# Set transforms and an optional transition on an element. If x, y or rotate
# values are numbers, append default units. Otherwise allow for passing
# strings with different x, y values or units. Alternatively, pass a string
# transform for a specific order of properties.
transform = (el, transform) ->
  if not el?
    return console.error "No element to style"

  if _.isObject(transform)
    { x, y, z, scale, skew, rotate, opacity } = transform

    x ?= 0
    y ?= 0
    z ?= 0
    skew ?= 0
    scale ?= 1
    rotate ?= 0

    x += "px" if typeof x is "number"
    y += "px" if typeof y is "number"
    skew += "deg" if typeof skew is "number"
    rotate += "deg" if typeof rotate is "number"

    # translate3d might not work well in safari, avoid it if you only use translate2d
    el.style[Prefix "transform"] = """
      translate3d(#{x}, #{y}, 0)
      skew(#{skew})
      scale(#{scale})
      rotate(#{rotate})
    """

    el.style.opacity = opacity if opacity?
    transition(el, transform.transition) if transform.transition?

  else if _.isString(transform)
    el.style[Prefix "transform"] = transform

# Just set a transition on an element. Query the elements `offsetLeft` if
# a DOM refresh is required to trigger subsequent animations.
transition = (el, transition, triggerRefresh) ->
  if not el?
    return console.error "No element to style"

  el.style[Prefix "transition"] = transition
  el.offsetLeft if triggerRefresh

module.exports = {
  getBounds
  transform
  transition
}
